import { Modal, Form, Row, Col, Select, Button, Card, Input, Typography, message } from "antd";
import React, { useState, useContext, useEffect } from "react";
import "../../../Styles/subtenant.css";
import Services from "../../../network/Services";
import { UserContext } from "../../../App";
import Address from "../../Address";
import PhoneInput from "react-phone-input-2";
import DatePickerComp from "../../DatePickerComp";
import ServiceProviderSelect from "./ServiceProviderSelect";
import { capitalizeFirstLetter,formatPhoneNumber, isNullUndefine } from "../../../control/Constant";

const { Option } = Select;
const { Text } = Typography;

// ── Shared styles ────────────────────────────────────────────────────────────
const labelStyle = { color: "#333", fontWeight: 500, marginBottom: 2, display: "block" };
const inputStyle =    { border: "1px solid #333", color: "#333", height: "2.3rem" };
const cardStyle = { border: "1px dashed #333", borderRadius: 5 };

// ── Section heading ──────────────────────────────────────────────────────────
const SectionHeading = ({ children, color = "#333" }) => (
  <Text strong style={{ color, fontSize: 14, display: "block", marginBottom: 12 }}>
    {children}
  </Text>
);

// ── Labelled Form.Item wrapper ───────────────────────────────────────────────
const LabeledItem = ({ label, name, rules, children }) => (
  <div style={{ marginBottom: 4 }}>
    <label style={labelStyle}>{label}</label>
    <Form.Item name={name} rules={rules} style={{ marginBottom: 0 }}>
      {children}
    </Form.Item>
  </div>
);

// ────────────────────────────────────────────────────────────────────────────

function AddProfessional({ visible, onCancel, updatePartnerUsersData }) {
  const { setLoader } = useContext(UserContext);
  const [form] = Form.useForm();
  const [latLongAgnt, setLatLongAgnt] = useState({ latitude: null, longitude: null });
  const [dateSatate, setDateSatate] = useState(null);
  // ── State ─────────────────────────────────────────────────────────────────
  // ── State ─────────────────────────────────────────────────────────────────
  const [contactList, setContactList] = useState([]);
  const [showContactModal, setShowContactModal] = useState(false);
  const [modalContact, setModalContact] = useState({
    contactTypeId: "",
    phone: "",
    commTypeId: "1",
    email: "",
    otherDescription: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [defaultContactType, setDefaultContactType] = useState("");
  const [defaultOtherDescription, setDefaultOtherDescription] = useState("");
  const [modalError, setModalError] = useState("");
  const [modalError1, setModalError1] = useState("");
  const [professionalPayload, setProfessionalPayload] = useState({
    main: null,
    others: [],
    otherMeta: {}, // 🔥 ADD THIS
  });
  const [submitClicked, setSubmitClicked] = useState(false);

  const isUpdateMode = updatePartnerUsersData && typeof updatePartnerUsersData === "object";

  // ── Handlers ─────────────────────────────────────────────────────────────

  const handleDateData = (date) => {
    setDateSatate(date);
    form.setFieldsValue({ dob: date });
  };

  const onChangePhone = (value) => {
    form.setFieldsValue({ mobile: value });
  };

  // ── Payload builder ───────────────────────────────────────────────────────

  const createProUserPayload = (contacts) => {
    const v = form.getFieldsValue();
    return {
      proUser: {
        userId: null,
        fName: v.fName || null,
        mName: v.mName || null,
        lName: v.lName || null,
        dob: v.dob ? new Date(v.dob).toISOString() : null,
        isPrimaryMember: false,
        genderId: v.genderId || null,
        proUserId: 0,
        websiteLink: v.websiteLink || null,
        businessName: v.businessName || null,
        subPost: v.subPost || null,
        linkedin: v.linkedin || null,
        facebook: v.facebook || null,
        instagram: v.instagram || null,
        youtube: v.youtube || null,
        isActive: true,
        isReviewed: null,
        reviewBasedProUserId: null,
        proCategories: professionalPayload?.main?.proCategories || []

      },
      proUserAddress: [
        {
          addressId: null,
          lattitude: latLongAgnt?.latitude || "0",
          longitude: latLongAgnt?.longitude || "0",
          addressLine1: v.address,
          addressLine2: "",
          addressLine3: "",
          zipcode: v.zipcode,
          county: v.county,
          city: v.city,
          state: v.state,
          country: v.country,
          addressTypeId: 1,
          countyRefId: null,
        },
      ],

      proUserEmail: contacts?.filter(item => item.email)?.map(item => ({ contactId: null, contactTypeId: Number(item.contactTypeId), emailId: item.email })),
      proUserMobile: contacts?.filter(item => item.phone)?.map(item => ({ contactId: null, contactTypeId: Number(item.contactTypeId), mobileNo: `+${item.phone}`, commTypeId: Number(item.commTypeId) || 1 })),
      upsertedBy: sessionStorage.getItem("loggedUserId") || '',
    };
  };

  // ── Submit ────────────────────────────────────────────────────────────────


  const buildOtherContactPayload = (contactList, payload, data) => {
    if (!contactList?.length) return null;
    const CREATED_BY = payload?.upsertedBy;
    const USER_ID = data?.data?.data?.userId;
    const OTHER_ID = "999999";
    const mobiles = [];
    const emails = [];
    contactList.forEach((item) => {
      // 👉 Only process "Other" type
      if (String(item?.contactTypeId) !== OTHER_ID) return;

      const commonFields = {
        contactTypeId: OTHER_ID,
        createdBy: CREATED_BY,
        contactType: "Other",
      };

      // ✅ MOBILE
      if (item?.phone) {
        mobiles.push({
          ...commonFields,
          mobileNo: item.phone,
          commTypeId: item?.commTypeId || "1",
          mobileOther: {
            othersName: item?.otherDescription || "", // ✅ FIXED
            othersCategoryId: 6,
            isActive: true,
            othersId: "",
            createdBy: CREATED_BY,
          },
        });
      }

      // ✅ EMAIL
      if (item?.email) {
        emails.push({
          ...commonFields,
          email: item.email,
          emailOther: {
            othersName: item?.otherDescription || "", // ✅ FIXED
            othersCategoryId: 6,
            isActive: true,
            othersId: "",
            createdBy: CREATED_BY,
          },
        });
      }
    });

    // ❌ avoid empty API call
    if (!mobiles.length && !emails.length) return null;

    return {
      userId: USER_ID,
      activityTypeId: "4",
      contact: {
        mobiles,
        emails,
      },
    };
  };

  const buildOthersMappingPayload = (othersRes, mainRes) => {
    const CREATED_BY = sessionStorage.getItem("loggedUserId") || '';
    const CATEGORY_ID = 28;

    const proCategories = mainRes?.data?.data?.proCategories || [];

    let payload = [];

    othersRes?.forEach((item, index) => {
      const original = professionalPayload?.others[index];

      if (!original) return;

      const matched = proCategories.find(
        (p) =>
          p.proTypeId === original.proTypeId &&
          (
            (p.proSubTypeId === null && original.proSubTypeId === null) ||
            p.proSubTypeId === original.proSubTypeId
          )
      );

      if (matched) {
        payload.push({
          othersCategoryId: CATEGORY_ID,
          othersId: item.othersId,
          othersMapNatureId: matched.proCatId,
          othersMapNatureType: "",
          isActive: true,
          createdBy: CREATED_BY,
          remarks: "",
        });
      }
    });

    return payload;
  };

  const onFinishForm = async () => {
    let updatedContactList = contactList;

    setSubmitClicked(true);
    if (!professionalPayload?.main?.proCategories?.length) {
      message.error("Please select at least one Service Provider");
      return;
    }



    if (!updatedContactList?.length) {
      updatedContactList = handleAddContact(false);
      if (!updatedContactList) return;
    }

    setLoader(true);

    try {
      // ✅ 1st API (MAIN)
      const payload = createProUserPayload(updatedContactList);
      const res = await Services.postAddmemberProfess(payload);

      // ✅ Contact Other API (existing)
      const json = buildOtherContactPayload(updatedContactList, payload, res);

      if (json) {
        await Services.postOtherContactType(json);
      }

      // ============================
      // ✅ 2nd API (CREATE OTHERS)
      // ============================


      const othersPayload = professionalPayload?.others || [];
      let othersRes = [];

      if (othersPayload.length > 0) {
        const USER_ID = res?.data?.data?.userId;
        const othersPayloads = othersPayload.map((item) => ({
          ...item,
          userId: USER_ID, // 🔥 inject here
        }));

        othersRes = await Services.createOthers(othersPayloads);
      }

      // ============================
      // ✅ 3rd API (MAPPING)
      // ============================
      if (othersRes?.data?.data?.length > 0) {
        const mappingPayload = buildOthersMappingPayload(othersRes?.data?.data, res, professionalPayload?.otherMeta);

        if (mappingPayload.length > 0) {
          await Services.postOthersMapData(mappingPayload);
        }
      }

      // ✅ SUCCESS
      message.success("Professional created Successfully");
      onCancel();

    } catch (err) {
      message.error(err?.response?.data?.Messages?.[0] || "Error creating Professional User");
    } finally {
      setLoader(false);
    }
  };



  const contactTypes = [
    { label: "Primary", value: "1" },
    { label: "Secondary", value: "2" },
    { label: "Work", value: "3" },
    { label: "Home", value: "4" },
    { label: "Fax", value: "5" },
    { label: "Other", value: "999999" }
  ];

  const phoneTypes = [
    { label: "Cell No.", value: "1" },
    { label: "Land Line", value: "2" }
  ];

  // ── Used/available types ──────────────────────────────────────────────────
  const usedTypes = contactList?.filter(c => c.id !== editingId)?.map(c => c.contactTypeId);
  const availableTypes = contactTypes?.filter(
    type =>
      type?.value === "999999" || !usedTypes.includes(type?.value)
  );



  const handleAddContact = (openModal) => {
    let updatedList = contactList;

    if (contactList?.length === 0) {
      const email = form.getFieldValue("email");
      const mobile = form.getFieldValue("mobile");
      const comType = form.getFieldValue("commTypeId");

      if (!defaultContactType) {
        setModalError1("Contact Type is required");
        return null; // ❗ important
      }

      if (!email) {
        form.validateFields(["email"]);
        return null;
      }

      updatedList = [{
        id: Date.now(),
        contactTypeId: defaultContactType || "",
        phone: mobile || "",
        commTypeId: comType || "1",
        email: email || "",
        otherDescription:
          defaultContactType === "999999" ? defaultOtherDescription : "",
      }];
      setContactList(updatedList);
      // clear only email + mobile
      form.setFieldsValue({
        email: undefined,
        mobile: undefined,
        contactTypeId: undefined,
      });
    }

    setModalContact({
      contactTypeId: "",
      phone: "",
      commTypeId: "1",
      email: "",
      otherDescription: "",
    });

    setDefaultContactType(undefined);
    setModalError("");
    setEditingId(null);

    if (openModal) {
      setShowContactModal(true);
    }

    return updatedList; // ✅ IMPORTANT
  };

  const validateModal = () => {
    if (!modalContact.contactTypeId) {
      setModalError1("Contact type is required.");
      return false;
    }
    if (!modalContact.email) {
      setModalError("Email is required.");
      return false;
    }
    const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(modalContact.email)) {
      setModalError("Please enter a valid email address.");
      return false;
    }
    setModalError("");
    return true;
  };

  const handleSaveContact = () => {
    if (!validateModal()) return;
    if (editingId) {
      setContactList(prev => prev.map(c => c.id === editingId ? { ...modalContact, id: editingId } : c));
    } else {
      setContactList(prev => [...prev, { ...modalContact, id: Date.now() }]);
    }
    setShowContactModal(false);
  };

  const handleSaveAndAddAnother = () => {
    if (!validateModal()) return;
    if (editingId) {
      setContactList(prev => prev.map(c => c.id === editingId ? { ...modalContact, id: editingId } : c));
    } else {
      setContactList(prev => [...prev, { ...modalContact, id: Date.now() }]);
    }
    setModalContact({ contactTypeId: "", phone: "", commTypeId: "1", email: "", otherDescription: "" });
    setModalError("");
    setEditingId(null);
    setShowContactModal(true);
  };

  const handleDeleteContact = (id) => {
    setContactList(prev => prev.filter(c => c.id !== id))
    resetErrors()
  };



  const resetErrors = () => {
    setModalError("");
    setModalError1("");
  };

  const handleEditContact = (contact) => {
    setModalContact(contact);
    setModalError("");
    setEditingId(contact.id);
    setShowContactModal(true);
  };


  const returnContactType = (id) => {

    return contactTypes?.find(item => item.value === id)?.label || "-";
  };
  const returnComType = (id) => {

    return phoneTypes?.find(item => item.value === id)?.label || "-";
  };

  const cloaseModal = () => {
    setShowContactModal(false);
    setModalContact({ contactTypeId: "", phone: "", commTypeId: "1", email: "", otherDescription: "" });
    resetErrors();
  }



  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <>
      <style>{`
      .Input::placeholder {
        color: #333 !important;
        opacity: 1;
      }
        .add-professional-modal .ant-select-selection-placeholder {
      color: #333 !important;
      opacity: 1;
    }
        /* ── PhoneInput border & placeholder ── */
  .add-professional-modal .react-tel-input {
    height: 100%;
    border: none !important;
    box-shadow: none !important;
  }
  .add-professional-modal .react-tel-input .form-control {
    border: none !important;
    box-shadow: none !important;
    color: #333 !important;
    width: 100% !important;
    height: 100% !important;
    background: transparent !important;
    padding-left: 52px !important;
  }

  .add-professional-modal .react-tel-input .form-control::placeholder {
    color: #333 !important;
    opacity: 1;
  }

  /* flag button border */
  .add-professional-modal .react-tel-input .flag-dropdown {
    border: none !important;
    border-right: 1px solid #333 !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }
  .add-professional-modal .react-tel-input .selected-flag {
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
    padding: 0 8px !important;
  }

  /* dropdown list */
  .add-professional-modal .react-tel-input .country-list {
    border: 1px solid #333 !important;
  }

  .add-professional-modal .react-tel-input .country-list .country-name {
    color: #333 !important;
  }
      
      `}
      </style>
      <Modal
        visible={visible}
        enforceFocus={false}
        onCancel={onCancel}
        footer={null}
        closable
        centered
        maskClosable={false}
        className="add-professional-modal"
        width={1000}
        style={{ top: 20 }}
        bodyStyle={{ padding: '14px', maxHeight: 'calc(100vh - 80px)', overflowY: 'auto', borderRadius: '8px' }}
      >
         <h5 className="mt-2">Create Professional</h5>
        <Form
          form={form}
          name="AdduserForm"
          layout="vertical"
          className="w-100"
          style={{
            width: "100%",
            // marginTop: 30,
            paddingRight: 5,
            maxHeight: "calc(100vh - 100px)",
            overflowY: "auto",
          }}
          onFinish={onFinishForm}
        >

          {/* ── Professional Type ── */}

          <Row className="w-100 mb-2" style={{ marginTop: 8, display: "contents" }}>
            {/* <ServiceProviderSelect/> */}
            <Card className="w-100 mt-2" style={cardStyle}>
              <ServiceProviderSelect onProfessionalChange={setProfessionalPayload} submitClicked={submitClicked} />
            </Card>

          </Row>

          {/* ── Personal Information ── */}
          <Card className="w-100 mt-2" style={cardStyle}>
            <SectionHeading color="#76272B">Personal Information</SectionHeading>

            <Row gutter={[16, 4]}>
              <Col xs={24} sm={12} md={8}>
                <LabeledItem
                  label="First Name *"
                  name="fName"
                  rules={[
                    { required: true, message: "First name is required" },
                    { min: 2, message: "Min 2 characters" },
                    { max: 50, message: "Max 50 characters" },
                  ]}
                >
                  <Input className="Input inputClass" placeholder="Enter first name" style={inputStyle}
                    onChange={(e) => {
                      const value = capitalizeFirstLetter(e.target.value);
                      form.setFieldsValue({ fName: value });
                    }} />
                </LabeledItem>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <LabeledItem
                  label="Middle Name"
                  name="mName"
                  rules={[{ max: 50, message: "Max 50 characters" }]}
                >
                  <Input className="Input" placeholder="Enter middle name" style={inputStyle}
                    onChange={(e) => {
                      const value = capitalizeFirstLetter(e.target.value);
                      form.setFieldsValue({ mName: value });
                    }} />
                </LabeledItem>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <LabeledItem
                  label="Last Name *"
                  name="lName"
                  rules={[
                    { required: true, message: "Last name is required" },
                    { min: 2, message: "Min 2 characters" },
                    { max: 50, message: "Max 50 characters" },
                  ]}
                >
                  <Input className="Input" placeholder="Enter last name" style={inputStyle}
                    onChange={(e) => {
                      const value = capitalizeFirstLetter(e.target.value);
                      form.setFieldsValue({ lName: value });
                    }} />
                </LabeledItem>
              </Col>
            </Row>

            <Row gutter={[16, 4]}>
              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 4 }}>
                  <label style={labelStyle}>Date of Birth</label>
                  <Form.Item name="dob" style={{ marginBottom: 0 }}>
                    <DatePickerComp
                      className="w-100"
                      placeholderText="Select date of birth"
                      handleDateData={handleDateData}
                      dateSatate={dateSatate}
                      setDateSatate={setDateSatate}
                      future="show"
                      id="addprofessional"
                    />
                  </Form.Item>
                </div>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <LabeledItem label="Gender" name="genderId"
                // rules={[{message: "Please select gender" }]}
                >
                  <Select
                    placeholder="Select gender"
                    className="newSelecte"
                  >
                    <Option value={1}>Male</Option>
                    <Option value={2}>Female</Option>
                  </Select>
                </LabeledItem>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <LabeledItem
                  label="Business Name"
                  name="businessName"
                  rules={[{ max: 100, message: "Max 100 characters" }]}
                >
                  <Input className="Input" placeholder="Enter business name" style={inputStyle}
                    onChange={(e) => {
                      const value = capitalizeFirstLetter(e.target.value);
                      form.setFieldsValue({ businessName: value });
                    }} />
                </LabeledItem>
              </Col>
            </Row>

            <Row gutter={[16, 4]}>
              <Col xs={24} sm={12} md={8}>
                <LabeledItem label="Designation" name="subPost">
                  <Input className="Input" placeholder="Enter your designation" style={inputStyle} />
                </LabeledItem>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <LabeledItem
                  label="Website Link"
                  name="websiteLink"
                  rules={[
                    { max: 200, message: "Max 200 characters" },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        try { new URL(value); return Promise.resolve(); }
                        catch { return Promise.reject("Enter a valid URL (e.g. https://example.com)"); }
                      },
                    },
                  ]}
                >
                  <Input className="Input" placeholder="https://example.com" style={inputStyle} />
                </LabeledItem>
              </Col>
            </Row>



          </Card>
          <Card className="w-100 mt-2" style={cardStyle}>
            <style>{`
    .contact-radio input[type="radio"] { accent-color: #720C20; }
    .contact-table td, .contact-table th { padding: 8px 12px; font-size: 13px; }
    .contact-table th { color: #6b7280; font-weight: 500; border-bottom: 1px solid #e5e7eb; }
    .contact-table td { border-bottom: 1px solid #f3f4f6; color: #333; }
    .contact-table tr:last-child td { border-bottom: none; }
    .react-tel-input .form-control { border: none !important; height: 100% !important; box-shadow: none !important; background: transparent !important; }
    .react-tel-input .flag-dropdown { border: none !important; background: transparent !important; }
            `}</style>

            {/* ── Default form — only when no contacts yet ── */}
            {contactList?.length === 0 ? (
              <>
                {/* Contact Type */}

                <div style={{ marginBottom: 12 }}>
                  <label style={labelStyle}>Contact Type *</label>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px 24px", marginTop: 6 }} className="contact-radio">
                    {contactTypes?.map((item) => (
                      <label key={item.value} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer", color: "#333" }}>
                        <input
                          type="radio"
                          name="contactTypeId"
                          value={item.label}
                          checked={defaultContactType === item?.value}
                          onChange={(e) => {
                            setDefaultContactType(item?.value); setModalError1("");
                          }}
                        />
                        {item.label}
                      </label>
                    ))}

                  </div>
                  {modalError1 && (
                    <p style={{ color: "#dc2626", fontSize: 12, marginTop: 4, marginBottom: 0 }}>
                      {modalError1}
                    </p>
                  )}


                  {defaultContactType === "999999" && (
                    <div style={{ marginTop: 10 }}>
                      <label style={labelStyle}>Other</label>
                      <input
                        type="text"
                        placeholder="Other Description"
                        value={defaultOtherDescription}
                        onChange={(e) => setDefaultOtherDescription(e.target.value)}
                        style={{
                          width: "100%", padding: "8px 12px",
                          border: "1px solid #333", borderRadius: 6,
                          fontSize: 13, color: "#333",
                          boxSizing: "border-box", marginTop: 4,
                        }}
                      />
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>

                  {/* Email — required */}
                  <div style={{ marginBottom: 4, width: '50%' }}>
                    <LabeledItem
                      label="Email Address *"
                      name="email"
                      rules={[
                        { required: true, message: "Email is required" },
                        {
                          validator: (_, value) => {
                            if (!value) return Promise.resolve();
                            const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
                            if (!emailRegex.test(value))
                              return Promise.reject("Please enter a valid email address");
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder="i.e johnoe@gmail.com"
                        className="Input"
                        disabled={isUpdateMode}
                        style={inputStyle}
                      />
                    </LabeledItem>
                  </div >


                  {/* Phone */}
                  <div style={{ marginBottom: 12 }}>
                    <label style={labelStyle}>Contact Number <span style={{ color: "#6b7280", fontWeight: 400 }}></span></label>

                    <div style={{ display: "flex", border: "1px solid #333", borderRadius: 6, height: 36 }}>
                      {/* Phone Input */}
                      <Form.Item
                        name="mobile"
                        style={{ flex: 1, marginBottom: 0 }}
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value?.length <= 3) return Promise.resolve();
                              const digits = value.replace(/\D/g, "");
                              if (digits?.length < 7) {
                                return Promise.reject("Enter a valid contact number");
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <PhoneInput
                          country="us"
                          preferredCountries={["us"]}
                          value={form.getFieldValue("mobile")}
                          onChange={onChangePhone}
                          countryCodeEditable={false}
                          placeholder="(555) 000-0000"
                          inputStyle={{
                            border: "none !important",
                            width: "100% !important",
                            height: "33px !important",
                            fontSize: "13px !important"
                          }}
                          buttonStyle={{
                            border: "none !important",
                            borderRight: "1px solid #333 !important",
                            background: "transparent !important"
                          }}
                          containerStyle={{
                            width: "100%"
                          }}
                        />
                      </Form.Item>

                      {/* Divider (optional clean UI) */}
                      <div style={{ width: 1, background: "#333" }} />

                      {/* Phone Type */}
                      <Form.Item name="commTypeId" style={{ marginBottom: 0 }}>
                        <select
                          style={{
                            border: "none",
                            outline: "none",
                            height: "100%",
                            padding: "0 10px",
                            fontSize: 13,
                            cursor: "pointer",
                            minWidth: 90
                          }}
                        >
                          {phoneTypes?.map((t) => (
                            <option key={t.value} value={t.value}>
                              {t.label}
                            </option>
                          ))}
                        </select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              // ── Contacts table ──
              <table className="contact-table" style={{ width: "100%", borderCollapse: "collapse", marginBottom: 4 }}>
                <thead>
                  <tr>
                    <th>Contact Type</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th style={{ textAlign: "right" }}>Edit/Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {contactList?.map((contact) => (
                    <tr key={contact.id}>
                      <td>
                        {contact.contactTypeId === "999999" && contact.otherDescription
                          ? `${contact.otherDescription}`
                          : returnContactType(contact.contactTypeId) || "-"}
                      </td>
                      <td>{contact.email || "-"}</td>
                      <td>{contact.phone ? `${formatPhoneNumber(contact.phone?.startsWith("+") ? contact.phone : `+${contact.phone}`)
                        } (${returnComType(contact.commTypeId)})` : "-"}</td>
                      <td style={{ textAlign: "right" }}>
                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>

                          <img
                            onClick={() => handleEditContact(contact)}
                            src="./images/edit-icon.png"
                            style={{ width: "16px", height: "16px", flexShrink: 0, cursor: "pointer" }}
                            alt="Location Preferred"
                          />

                          <img
                            onClick={() => handleDeleteContact(contact.id)}
                            src="./images/delete-icon.png"
                            style={{ width: "16px", height: "16px", flexShrink: 0, cursor: "pointer" }}
                            alt="Location Preferred"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* ── Add another contact ── */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
              <button type="button" onClick={() => handleAddContact(true)}
                style={{
                  background: "none", border: "none", color: "#720C20",
                  fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 4,
                }}
              >
                <span style={{ fontSize: 18, lineHeight: 1 }}>+</span> Add another contact
              </button>
            </div>

            {/* ── Modal ── */}
            {showContactModal && (
              <div style={{
                position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <div style={{ background: "#fff", borderRadius: 10, padding: 24, width: "100%", maxWidth: 440 }}>

                  {/* Header */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <span className="fw-bold" style={{ fontSize: 15, fontWeight: 500, color: "#333" }}>
                      {editingId ? "Edit contact information" : "Add contact information"}
                    </span>
                    <button type="button" onClick={() => cloaseModal()}
                      style={{
                        background: "none", border: "none", fontWeight: "800",
                        cursor: "pointer", fontSize: 18, color: "#333333",
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}>
                      ✕
                    </button>
                  </div>

                  {/* Contact Type */}
                  <div style={{ marginBottom: 14 }}>
                    <label style={labelStyle}>Contact Type *</label>
                    {availableTypes?.length === 0 ? (
                      <p style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>All contact types have been used.</p>
                    ) : (
                      <>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px 24px", marginTop: 6 }} className="contact-radio">
                          {availableTypes?.map((item) => (
                            <label key={item.value} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer", color: "#333" }}>
                              <input
                                type="radio"
                                name="modalContactType"
                                value={item.value}
                                checked={modalContact.contactTypeId === item.value}
                                onChange={() => {
                                  setModalContact(prev => ({
                                    ...prev,
                                    contactTypeId: item.value,
                                    otherDescription: ""
                                  }));
                                  setModalError1("");
                                }}
                              />
                              {item.label}
                            </label>
                          ))}

                        </div>
                        {modalError1 && (
                          <p style={{ color: "#dc2626", fontSize: 12, marginTop: 4, marginBottom: 0 }}>
                            {modalError1}
                          </p>
                        )}
                      </>

                    )}

                    {/* Other description */}
                    {modalContact?.contactTypeId === "999999" && (
                      <div style={{ marginTop: 10 }}>
                        <label style={labelStyle}>Other</label>
                        <input
                          type="text"
                          placeholder="Other Description"
                          value={modalContact?.otherDescription || ""}
                          onChange={(e) => setModalContact(prev => ({ ...prev, otherDescription: e.target.value }))}
                          style={{
                            width: "100%", padding: "8px 12px",
                            border: "1px solid #333", borderRadius: 6,
                            fontSize: 13, color: "#333",
                            boxSizing: "border-box", marginTop: 4,
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* Phone — optional */}
                  <div style={{ marginBottom: 14 }}>
                    <label style={labelStyle}>
                      Contact Number <span style={{ color: "#6b7280", fontWeight: 400 }}></span>
                    </label>
                    <div style={{ display: "flex", border: "1px solid #333", borderRadius: 6 }}>
                      <PhoneInput
                        regions={["america", "europe", "asia", "oceania", "africa"]}
                        country="us"
                        preferredCountries={["us"]}
                        value={modalContact.phone}
                        onChange={(val) => setModalContact(prev => ({ ...prev, phone: val }))}
                        countryCodeEditable={false}
                        placeholder="(555) 000-0000"
                        inputStyle={{ border: "none", width: "100%", boxShadow: "none" }}
                        buttonStyle={{ border: "none", borderRight: "1px solid #333", background: "transparent", borderRadius: 0 }}
                        containerStyle={{ flex: 1, borderRight: "1px solid #333" }}
                      />
                      <select
                        value={modalContact.commTypeId}
                        onChange={(e) => setModalContact(prev => ({ ...prev, commTypeId: e.target.value }))}
                        style={{
                          border: "none", outline: "none",
                          padding: "8px 10px", fontSize: 13,
                          color: "#333", background: "#fff",
                          cursor: "pointer", minWidth: 90,
                          borderRadius: "0 6px 6px 0"
                        }}
                      >
                        {phoneTypes?.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                      </select>
                    </div>
                  </div>

                  {/* Email — required */}
                  <div style={{ marginBottom: 6 }}>
                    <label style={labelStyle}>Email Address *</label>
                    <input
                      type="email"
                      placeholder="i.e johnoe@gmail.com"
                      value={modalContact?.email}
                      onChange={(e) => {
                        setModalContact(prev => ({ ...prev, email: e.target.value }));
                        setModalError("");
                      }}
                      style={{
                        width: "100%", padding: "8px 12px",
                        border: `1px solid ${modalError ? "#dc2626" : "#333"}`,
                        borderRadius: 6, fontSize: 13, color: "#333", boxSizing: "border-box",
                      }}
                    />
                    {/* Validation error */}
                    {modalError && (
                      <p style={{ color: "#dc2626", fontSize: 12, marginTop: 4, marginBottom: 0 }}>
                        {modalError}
                      </p>
                    )}
                  </div>

                  {/* Footer */}
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
                    {!editingId && (
                      <button type="button" onClick={handleSaveAndAddAnother}
                        style={{
                          padding: "8px 16px", border: "1.5px solid #720C20",
                          borderRadius: 6, background: "transparent",
                          color: "#720C20", fontSize: 13, cursor: "pointer", fontWeight: 500,
                        }}>
                        Save & Add Another contact
                      </button>
                    )}
                    <button type="button" onClick={handleSaveContact}
                      style={{
                        padding: "8px 20px", border: "none",
                        borderRadius: 6, background: "#720C20",
                        color: "#fff", fontSize: 13, cursor: "pointer", fontWeight: 500,
                      }}>
                      Save
                    </button>
                  </div>

                </div>
              </div>
            )}

          </Card>

          {/* ── Social Information ── */}
          <Card className="w-100 mt-2" style={cardStyle}>
            <SectionHeading color="#720C20">Social Information</SectionHeading>

            <Row gutter={[16, 4]}>
              <Col xs={24} sm={12} md={8}>
                <LabeledItem label="LinkedIn URL" name="linkedin">
                  <Input className="Input" placeholder="https://linkedin.com/in/..." style={inputStyle} />
                </LabeledItem>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <LabeledItem label="Facebook URL" name="facebook">
                  <Input className="Input" placeholder="https://facebook.com/..." style={inputStyle} />
                </LabeledItem>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <LabeledItem label="Instagram URL" name="instagram">
                  <Input className="Input" placeholder="https://instagram.com/..." style={inputStyle} />
                </LabeledItem>
              </Col>
            </Row>

            <Row gutter={[16, 4]}>
              <Col xs={24} sm={12} md={8}>
                <LabeledItem label="YouTube URL" name="youtube">
                  <Input className="Input" placeholder="https://youtube.com/..." style={inputStyle} />
                </LabeledItem>
              </Col>
            </Row>
          </Card>
          {/* ── Contact Address ── */}
          <Card className="w-100 mt-2"   style={{ ...cardStyle, marginBottom: "24px" }}>
            <SectionHeading color="#720C20">Contact Address</SectionHeading>
            <Address
              form={form}
              updatePartnerUsersData={updatePartnerUsersData}
              setLatLongAgnt={setLatLongAgnt}
              id="addprofessional"
            />
          </Card>
          {/* ── Footer ── */}
             <Row className="mt-3 w-100" style={{ borderTop: "1px solid #d9d9d9", paddingTop: "24px" }}>
            <Col className="w-100 d-flex justify-content-between">
              <Button
                className="fw-bold"
                onClick={onCancel}
                style={{ color: "#720C20", borderColor: "#720C20", borderRadius: 5, height:"44px", minWidth:"90px"  }}
              >
                Cancel
              </Button>
              <Button
                className="fw-bold"
                htmlType="submit"
                style={{ background: "#720C20", color: "white", borderRadius: 5, height:"44px", minWidth:"90px"  }}
              >
                {isUpdateMode ? "Update" : "Save"}
              </Button>
            </Col>
          </Row>

        </Form>
      </Modal>
    </>
  );
}
export default AddProfessional;